export const ngxUiLoaderConfig = {
  pbColor: '#0086e9',
  fgsColor: '#0086e9',
  pbThickness: 3, // progress bar thickness
  overlayColor: 'rgba(40,40,40,0.12)',
  blur: 2,
};
